module.exports = __webpack_public_path__ + "../resources/images/illustration_error-e31210f61e0aaca538d26e35d05e1d2b.svg";